import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import space.stanton.labs.LabsPage as _space_stanton_labs_LabsPage
import space.stanton.pages.HomePage as _space_stanton_pages_HomePage
import space.stanton.pages.pages.About_mePage as _space_stanton_pages_pages_About_mePage
import space.stanton.pages.posts.Bp_2024_06_14_helloPage as _space_stanton_pages_posts_Bp_2024_06_14_helloPage
import space.stanton.pages.posts.Bp_2024_08_11_why_i_love_kotlinPage as _space_stanton_pages_posts_Bp_2024_08_11_why_i_love_kotlinPage
import space.stanton.pages.posts.Bp_2025_05_17_where_it_all_beganPage as _space_stanton_pages_posts_Bp_2025_05_17_where_it_all_beganPage
import space.stanton.pages.posts.Bp_2025_08_25_a_few_useful_bash_commandsPage as _space_stanton_pages_posts_Bp_2025_08_25_a_few_useful_bash_commandsPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "blog", "buildType" to "RELEASE", "hey" to "there"))
    BasePath.set("/")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _space_stanton_pages_HomePage()
        }
        ctx.router.register(
            "/pages/about-me",
            initRouteMethod = { ctx ->
                space.stanton.pages.pages.initAbout_mePage(ctx)
            },
        ) { pageCtx -> 
            _space_stanton_pages_pages_About_mePage()
        }
        ctx.router.register(
            "/pages/labs",
        ) { pageCtx -> 
            _space_stanton_labs_LabsPage()
        }
        ctx.router.register(
            "/posts/bp-2024-06-14-hello",
            initRouteMethod = { ctx ->
                space.stanton.pages.posts.initBp_2024_06_14_helloPage(ctx)
            },
        ) { pageCtx -> 
            _space_stanton_pages_posts_Bp_2024_06_14_helloPage()
        }
        ctx.router.register(
            "/posts/bp-2024-08-11-why-i-love-kotlin",
            initRouteMethod = { ctx ->
                space.stanton.pages.posts.initBp_2024_08_11_why_i_love_kotlinPage(ctx)
            },
        ) { pageCtx -> 
            _space_stanton_pages_posts_Bp_2024_08_11_why_i_love_kotlinPage()
        }
        ctx.router.register(
            "/posts/bp-2025-05-17-where-it-all-began",
            initRouteMethod = { ctx ->
                space.stanton.pages.posts.initBp_2025_05_17_where_it_all_beganPage(ctx)
            },
        ) { pageCtx -> 
            _space_stanton_pages_posts_Bp_2025_05_17_where_it_all_beganPage()
        }
        ctx.router.register(
            "/posts/bp-2025-08-25-a-few-useful-bash-commands",
            initRouteMethod = { ctx ->
                space.stanton.pages.posts.initBp_2025_08_25_a_few_useful_bash_commandsPage(ctx)
            },
        ) { pageCtx -> 
            _space_stanton_pages_posts_Bp_2025_08_25_a_few_useful_bash_commandsPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("blog", space.stanton.components.theme.BlogStyle)
        ctx.theme.registerStyle("blog-item", space.stanton.components.widgets.BlogItemStyle)
        ctx.theme.registerStyle("nav-link", space.stanton.components.widgets.NavLinkStyle)
        space.stanton.components.theme.initSilk(ctx)
    }

    router.tryRoutingTo(BasePath.remove(window.location.href.removePrefix(window.origin)), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        space.stanton.components.theme.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
